import { useIntegrationsMap } from "../IntegrationProvider";

export function useIntegration(integrationId: string | undefined | null) {
  const integrations = useIntegrationsMap();
  if (integrationId == null) {
    return null;
  }
  return integrations.get(integrationId) ?? null;
}
